import styled from "styled-components"

import { minWidth } from "utils"

export const MobileSwapWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: wrap;

  ${minWidth.mobile`
    display: block;
  `};
`
